import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export function useAdminGrantsFlag(): boolean {
  const user = useUser();
  return useFliptBoolean("admin-grants", false, user?.email);
}
